/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useRef } from "react";
// @material-ui/core components
import { red } from "@material-ui/core/colors";
import axios from "utils/httpClient";
import { buildVehicleAssignmentPayload, assignmentResourceOptions, assertAssignmentResources, calculateTurnPassengers } from "./assignmentUtils";
import useAssignmentAvailability from "./useAssignmentAvailability";
import VehicleAssignmentTurnEditor from "./VehicleAssignmentTurnEditor";
import VehicleAssignmentCancellationDialog from "./VehicleAssignmentCancellationDialog";
import { VehicleAdminGuard } from "./vehicleAuth";
import clsx from "clsx";
import {
    TextField,
    Button,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    TableSortLabel,
    TableFooter,
    TablePagination,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Chip,
    Tooltip
} from "@material-ui/core";

import IconButton from "@material-ui/core/IconButton";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

import FirstPageIcon from "@material-ui/icons/FirstPage";
import LastPageIcon from "@material-ui/icons/LastPage";
import KeyboardArrowLeft from "@material-ui/icons/KeyboardArrowLeft";
import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";

import Typography from "@material-ui/core/Typography";
import EditIcon from "@material-ui/icons/Edit";
import { makeStyles } from "@material-ui/core/styles";

import {
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    FormGroup,
    Label,
    Input,
    Row,
    InputGroupAddon,
    InputGroupText,
    InputGroup
} from "reactstrap";

// core components
import Grid from "components/Grid/GridContainer";

import Col from "components/Grid/GridItem";
import Card from "components/Card/Card.js";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions";
import Collapse from "@material-ui/core/Collapse";
import CardHeader from "components/Card/CardHeader.js";
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import Button2 from "components/CustomButtons/Button.js";
import { authHeader } from "_helpers";
import TSText from "components/Forms/TSText";
import TSSelect2 from "components/Forms/TSSelect2";
import TSSelectMultiple from "components/Forms/TSSelectMultiple";
import Checkbox from "@material-ui/core/Checkbox";
import TSUser from "components/Forms/TSUser";
import Datetime from "react-datetime";
import "react-datetime/css/react-datetime.css";
import "./custom-style.css";
import { color } from "highcharts";
import { s } from "@fullcalendar/core/internal-common";
import zIndex from "@material-ui/core/styles/zIndex";

const useStyles = makeStyles(theme => ({
    cardCategoryWhite: {
        color: "rgba(255,255,255,.62)",
        margin: "0",
        fontSize: "14px",
        marginTop: "0",
        marginBottom: "0",
        flexGrow: 1
    },
    cardTitle: {
        textAlign: "center"
    },
    cardTitleWhite: {
        color: "#FFFFFF",
        marginTop: "0px",
        minHeight: "auto",
        fontWeight: "300",
        // fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
        fontFamily: '"Sarabun", sans-serif',
        marginBottom: "3px",
        textDecoration: "none",
        flexGrow: 1
    },
    collaps: {
        paddingLeft: "40px",
        paddingTop: "40px",
        display: "flex",
        flexDirection: "column-reverse"
    },
    expand: {
        transform: "rotate(0deg)",
        marginLeft: "auto",
        transition: theme.transitions.create("transform", {
            duration: theme.transitions.duration.shortest
        }),
        ...StyleSheet.absoluteFillObject,
        alignSelf: "flex-end",
        position: "absolute" // add if dont work with above
    },
    expandOpen: {
        transform: "rotate(180deg)"
    },
    visible: {
        opacity: 1,
        transition: "opacity 0.5s ease"
    },
    hidden: {
        opacity: 0,
        transition: "opacity 0.5s ease"
    },
    avatar: {
        backgroundColor: red[500]
    },
    tableContainer: {
        width: "99.99%",
        overflowX: "auto" // ทำให้ตารางสามารถเลื่อนในแนวนอนเมื่อกว้างเกินไป
    },
    tableRow: {
        "&:nth-of-type(odd)": {
            backgroundColor: theme.palette.action.hover
        }
    },
    tableCell: {
        padding: "2px"
    },
    modalFullscreen: {
        width: "100%",
        height: "100%",
        margin: 0,
        maxWidth: "100%"
    },
    modalContent: {
        height: "100%",
        borderRadius: 0
    },
    modalBody: {
        overflowY: "auto"
    },
    pagination: {
        flexShrink: 0,
        marginLeft: theme.spacing(2.5)
    },
    cardXs: {
        width: 75,
        height: 110,
        paddingTop: 10,
        margin: 2,
        textAlign: "center",
        margin: "3px",
        transition: "0.3s",
        display: "inline-block",
        boxShadow: "0 8px 40px -12px rgba(0,0,0,0.3)",
        "&:hover": {
            boxShadow: "0 16px 70px -12.125px rgba(0,0,0,0.3)"
        }
    },
    cardSm: {
        width: 180,
        height: 140,
        textAlign: "center",
        margin: "3px",
        transition: "0.3s",
        display: "inline-block",
        boxShadow: "0 8px 40px -12px rgba(0,0,0,0.3)",
        "&:hover": {
            boxShadow: "0 16px 70px -12.125px rgba(0,0,0,0.3)"
        }
    },
    cardImg1: {
        width: 60,
        height: 60,
        borderRadius: 60 / 2,
        objectFit: "cover",
        objectPosition: "100% 0"
    },
    cardImg2: {
        width: 100,
        height: 100,
        borderRadius: 100 / 2,
        objectFit: "cover",
        objectPosition: "100% 0"
    }
}));

const VehicleQueueManage = props => {
    const tableText = "จัดรถ";

    const host = ""; //'https://e.trangskin.go.th';
    var moment = require("moment");
    require("moment/locale/th");
    const classes = useStyles();

    const [currentDate, setcurrentDate] = useState(moment());
    const [holidayText, setHolidayText] = useState("");
    const [holidays, setHolidays] = useState([]);

    const [dataList, setDataList] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);
    const [arrTurnGo, setArrTurnGo] = useState([]);
    const [arrTurnBack, setArrTurnBack] = useState([]);
    const [selectedData, setSelectedData] = useState(null);

    //page & order
    const [orderDirection, setOrderDirection] = useState("desc");
    const [orderBy, setOrderBy] = useState("calYear"); // default column to sort
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(25);

    const [expanded, setExpanded] = React.useState(false);

    const [isEditing, setIsEditing] = useState(false);
    const [IsValid, setIsValid] = React.useState(true);

    const [isNewTurn, setisNewTurn] = useState(false);
    const [isReadySave, setIsReadySave] = useState(false);
    const [savingAssignments, setSavingAssignments] = useState(false);
    const savingAssignmentsRef = useRef(false);
    const [assignmentError, setAssignmentError] = useState("");
    const [assignmentSuccess, setAssignmentSuccess] = useState("");
    const [editingTurn, setEditingTurn] = useState(null);
    const [cancelTarget, setCancelTarget] = useState(null);
    const [cancellingAssignment, setCancellingAssignment] = useState(false);
    const cancellingAssignmentRef = useRef(false);
    const [editIndex, setEditIndex] = useState(null);


    //const [ArrTMoney, setTMoney] = useState([]);
    //const [ArrKMoney, setKMoney] = useState([]);

    const ArrStillTurnType = [
        { value: 1, label: "ไปกลับ" },
        { value: 2, label: "เฉพาะขาไป" },
        { value: 3, label: "เฉพาะขากลับ" }
    ];

    const [ArrTurnType, setArrTurnType] = useState([
        { value: 1, label: "ไปกลับ" },
        { value: 2, label: "เฉพาะขาไป" },
        { value: 3, label: "เฉพาะขากลับ" }
    ]);

    const [ArrVehicle, setArrVehicle] = useState([]);

    const [ArrVB, setArrVB] = useState([]);

    const [TurnKey, setTurnKey] = useState(0);
    const [VehicleKey, setVehicleKey] = useState(0);
    const [VBKey, setVBKey] = useState(0);
    const [TypeKey, setTypeKey] = useState(0);

    const arrTime = [
        { label: "7:00 น.", value: "07:00", isDisabled: false },
        { label: "7:30 น.", value: "07:30", isDisabled: false },
        { label: "8:00 น.", value: "08:00", isDisabled: false },
        { label: "8:30 น.", value: "08:30", isDisabled: false },
        { label: "9:00 น.", value: "09:00", isDisabled: false },
        { label: "9:30 น.", value: "09:30", isDisabled: false },
        { label: "10:00 น.", value: "10:00", isDisabled: false },
        { label: "10:30 น.", value: "10:30", isDisabled: false },
        { label: "11:00 น.", value: "11:00", isDisabled: false },
        { label: "11:30 น.", value: "11:30", isDisabled: false },
        { label: "12:00 น.", value: "12:00", isDisabled: false },
        { label: "12:30 น.", value: "12:30", isDisabled: false },
        { label: "13:00 น.", value: "13:00", isDisabled: false },
        { label: "13:30 น.", value: "13:30", isDisabled: false },
        { label: "14:00 น.", value: "14:00", isDisabled: false },
        { label: "14:30 น.", value: "14:30", isDisabled: false },
        { label: "15:00 น.", value: "15:00", isDisabled: false },
        { label: "15:30 น.", value: "15:30", isDisabled: false },
        { label: "16:00 น.", value: "16:00", isDisabled: false },
        { label: "16:30 น.", value: "16:30", isDisabled: false },
        { label: "17:00 น.", value: "17:00", isDisabled: false },
        { label: "17:30 น.", value: "17:30", isDisabled: false },
        { label: "18:00 น.", value: "18:00", isDisabled: false },
        { label: "18:30 น.", value: "18:30", isDisabled: false },
        { label: "19:00 น.", value: "19:00", isDisabled: false },
        { label: "19:30 น.", value: "19:30", isDisabled: false },
        { label: "20:00 น.", value: "20:00", isDisabled: false },
        { label: "20:30 น.", value: "20:30", isDisabled: false }
    ];

    const arrTime2 = [
        { label: "07:30 น.", value: "07:30", isDisabled: false },
        { label: "8:00 น.", value: "08:00", isDisabled: false },
        { label: "8:30 น.", value: "08:30", isDisabled: false },
        { label: "9:00 น.", value: "09:00", isDisabled: false },
        { label: "9:30 น.", value: "09:30", isDisabled: false },
        { label: "10:00 น.", value: "10:00", isDisabled: false },
        { label: "10:30 น.", value: "10:30", isDisabled: false },
        { label: "11:00 น.", value: "11:00", isDisabled: false },
        { label: "11:30 น.", value: "11:30", isDisabled: false },
        { label: "12:00 น.", value: "12:00", isDisabled: false },
        { label: "12:30 น.", value: "12:30", isDisabled: false },
        { label: "13:00 น.", value: "13:00", isDisabled: false },
        { label: "13:30 น.", value: "13:30", isDisabled: false },
        { label: "14:00 น.", value: "14:00", isDisabled: false },
        { label: "14:30 น.", value: "14:30", isDisabled: false },
        { label: "15:00 น.", value: "15:00", isDisabled: false },
        { label: "15:30 น.", value: "15:30", isDisabled: false },
        { label: "16:00 น.", value: "16:00", isDisabled: false },
        { label: "16:30 น.", value: "16:30", isDisabled: false },
        { label: "17:00 น.", value: "17:00", isDisabled: false },
        { label: "17:30 น.", value: "17:30", isDisabled: false },
        { label: "18:00 น.", value: "18:00", isDisabled: false },
        { label: "18:30 น.", value: "18:30", isDisabled: false },
        { label: "19:00 น.", value: "19:00", isDisabled: false },
        { label: "19:30 น.", value: "19:30", isDisabled: false },
        { label: "20:00 น.", value: "20:00", isDisabled: false },
        { label: "20:30 น.", value: "20:30", isDisabled: false },
        { label: "21:00 น.", value: "21:00", isDisabled: false }
    ];

    const [ArrStartTime, setArrStartTime] = useState(arrTime);
    const [ArrEndTime, setArrEndTime] = useState(arrTime2);

    const [StartTime, setStartTime] = useState("");
    const [EndTime, setEndTime] = useState("");

    const [vehicleAssignments, setVehicleAssignments] = useState([
        {
            startDatetime: null,
            startTime: null,
            endDatetime: null,
            endTime: null,
            turnKey: null,
            vehicleKey: null,
            vbKeyGo: [],
            vbKeyBack: [],
            arrStartTime: [],
            arrEndTime: []
        }
    ]);
    const [vehicleAssignments2, setVehicleAssignments2] = useState([
        {
            startDatetime: null,
            startTime: null,
            endDatetime: null,
            endTime: null,
            turnKey: null,
            vehicleKey: null,
            vbKeyGo: [],
            vbKeyBack: [],
            arrStartTime: [],
            arrEndTime: []
        }
    ]);

    const [displayRequest, setDisplayRequest] = useState([
        {
            vbid: null,
            value: null,
            endPlace: null,
            label: null,
            vbObjective: null,
            totalPassenger: 0,
            startDatetime: null,
            endDatetime: null,
            vehicleKey: null,
            driverKey: null,
            vehicleStartDatetime: null,
            vehicleEndDatetime: null
        }
    ]);

    //const [TMoneyKey, setTMoneyKey] = useState(0);
    //const [KMoneyKey, setKMoneyKey] = useState(0);
    const [Keyword, setKeyword] = useState("");
    const [StartDatetime, setStartDatetime] = useState("");

    const [modalHoliday, setModalHoliday] = useState(false);
    const [modalOpen, setModalOpen] = useState(false);
    const [modal, setModal] = useState(false);
    const [modal2, setModal2] = useState(false);
    const [errMsg, setErrMsg] = useState([]);
    const [modalError, setModalError] = useState(false);
    const [icon, setIcon] = useState("far fa-question-circle");
    const draftIndex = vehicleAssignments.length - 1;
    const draftAvailability = useAssignmentAvailability(vehicleAssignments[draftIndex]);
    const draftPassengers = calculateTurnPassengers(vehicleAssignments[draftIndex]);
    const draftOptions = assignmentResourceOptions(draftAvailability.data, vehicleAssignments[draftIndex], vehicleAssignments, draftIndex, draftPassengers.requiredCapacity);
    /*
          useEffect(() => {
      
              //ใช้สำหรับ Bind ข้อมูลใส่ Arr Combobox
              
              axios(host+"/api/v1/asset/assettype")
              .then(
                result => {
                      var json = JSON.parse(JSON.stringify(result.data.data).split('"name":').join('"label":').split('"typeKey":').join('"value":'));
                      setAssetType(json)
                  }, error => { console.log(error); }
              );  
              
      
          }, []);
      */
    //ใช้สำหรับ Bind ข้อมูลใส่ Arr Combobox Level 2
    /*
      useEffect(() => {
          fetchCatgory(TypeKey);
      }, [TypeKey]);//เมื่อ Combobox Level 1 มีการเปลี่ยนค่า
      */

    //Bind Data หลักของ Table
    useEffect(() => {
        //if(StartDatetime != null && StartDatetime != "")
        fetchDataList();
    }, [StartDatetime]); //Bind ใหม่เมื่อ Keyword หรือ ค่าอื่นๆ มีการเปลี่ยน เช่น [Keyword, TypeKey]


    // Use useEffect to run validateTurn when vehicleAssignments is updated
    useEffect(() => {
        //setIsValid(); // Now this runs with the updated vehicleAssignments
        validateTurn(vehicleAssignments);
    }, [vehicleAssignments.length, selectedRows.length]);

    useEffect(() => {
        axios("/api/v1/vehicle/vehicle").then(
            result => {
                var json = JSON.parse(
                    JSON.stringify(result.data.data)
                        .split('"name":')
                        .join('"label":')
                        .split('"vehicleKey":')
                        .join('"value":')
                );
                setArrVehicle(json);
            },
            error => {
                console.log(error);
            }
        );

        console.log(displayRequest)
    }, []); //Bind ใหม่เมื่อ Keyword หรือ ค่าอื่นๆ มีการเปลี่ยน เช่น [Keyword, TypeKey]

    const fetchDataList = async () => {
        try {
            const response = await axios.get(
                host + "/api/v1/vehiclebooking/assignments/bookings",
                { params: StartDatetime ? { startDatetime: StartDatetime } : {} }
            );
            if (response.data.result == 200) {
                setDataList(response.data.data);
            } else setDataList([]);
        } catch (error) {
            console.error("Error fetching dataList:", error);
            setDataList([]);
        }
    };

    // Toggle row selection

    const handleSelectRow = id => {
        if (cancellingAssignmentRef.current) return;
        if (!dataList.some(booking => booking.vbid === id && booking.canAssign)) return;
        setSelectedRows(prevSelected =>
            prevSelected.includes(id)
                ? prevSelected.filter(item => item !== id)
                : [...prevSelected, id]
        );
    };

    const handleGenerateJSON = () => {
        if (cancellingAssignmentRef.current) return;
        setAssignmentError("");
        setAssignmentSuccess("");
        const selectedData = dataList
            .filter(data => data.canAssign && selectedRows.includes(data.vbid))
            .map(item => {
                const passCount = item.totalPassenger || 0;
                return {
                    value: item.vbid,
                    label: `${item.startPlace || "-"} → ${item.endPlace || "-"} (${passCount} คน)${Number(item.isOneWay) === 1 ? " (เที่ยวเดียว)" : ""}`,
                    vbid: item.vbid,
                    startPlace: item.startPlace,
                    endPlace: item.endPlace,
                    vbObjective: item.vbObjective,
                    totalPassenger: passCount,
                    isOneWay: Number(item.isOneWay) === 1 ? 1 : 0,
                    startDatetime: item.startDatetime,
                    endDatetime: item.endDatetime
                    //...item
                };
            });

        if (!selectedData.length) {
            setAssignmentError("กรุณาเลือกรายการที่ยังไม่ได้จัดรถ");
            return;
        }
        setSelectedRows(selectedData);
        setDisplayRequest(selectedData);
        setArrTurnGo(selectedData);
        setArrTurnBack(selectedData.filter(booking => booking.isOneWay !== 1));
        //console.log(selectedData); // You can show this in an alert or a modal if needed

        const unselectedData = dataList.filter(data => !selectedRows.includes(data.vbid));  
        console.log(selectedData)
        setDataList(unselectedData);

    };

    // Add new vehicle assignment entry
    const handleAddAssignment = () => {
        try {
            buildVehicleAssignmentPayload(vehicleAssignments, selectedRows, { requireComplete: false });
            assertAssignmentResources(vehicleAssignments[draftIndex], draftOptions, draftAvailability.ready, draftPassengers.requiredCapacity);
            setAssignmentError("");
        } catch (error) {
            setAssignmentError(error.message);
            return;
        }

        //มีปัญหา ลบแล้วยังจำ ค่าเดิม

        if (checkTurnOver(vehicleAssignments)) { //เช็คว่าเที่ยวที่ขอใช้ ลงรถครบหรือยัง ถ้ายัง ให้เพิ่ม popup ลงเพิ่ม
            setVehicleAssignments([
                ...vehicleAssignments,
                {
                    startDatetime: null,
                    startTime: null,
                    endDatetime: null,
                    endTime: null,
                    turnKey: null,
                    vehicleKey: null,
                    vbKeyGo: [],
                    vbKeyBack: [],
                    arrStartTime: [],
                    arrEndTime: []
                }
            ]);

            setisNewTurn(true);
        }
        else {
            setIsReadySave(true);
        }

        const output = selectedRows.map((item) => {
            // ค้นหาการจัดรถที่มี vbid นี้ในรายการ vbKeyGo
            const matchedGo = vehicleAssignments.find(va =>
                (va.vbKeyGo || []).some(v => v.vbid === item.vbid)
            );

            const matchedBack = vehicleAssignments.find(va =>
                (va.vbKeyBack || []).some(v => v.vbid === item.vbid)
            );
            

            if (matchedGo || matchedBack) {
                return {
                    ...item,
                    //label: item.label,
                    //vbid: item.vbid,
                    goVehicleKey: matchedGo ? matchedGo.vehicleKey : null,
                    backVehicleKey: (matchedBack) ? matchedBack.vehicleKey : null,
                    goDriverUserName: matchedGo?.driverUserName,
                    backDriverUserName: matchedBack?.driverUserName,
                    vehicleStartDatetime: matchedGo ? matchedGo.startDatetime + 'T' + matchedGo.startTime : null,
                    vehicleEndDatetime: matchedBack ? matchedBack.endDatetime + 'T' + matchedBack.endTime : null
                };
            }

            return null; // ถ้าไม่พบการแมป
            }).filter(Boolean); // ลบค่าที่เป็น null ออก

            const mergedData = displayRequest.map(item => {
                const match = output.find(o => o.vbid === item.vbid);
                return match ? { ...item, ...match } : item;
            });
            setDisplayRequest(mergedData);
        };



    // Remove an assignment entry by index
    const handleRemoveAssignment = index => {
        setVehicleAssignments(prevAssignments => {
            // Filter out the assignment by index
            const updatedAssignments = prevAssignments.filter((_, i) => i !== index);

            // Check if there are remaining assignments and modify the last one
            if (updatedAssignments.length > 0) {
                const lastIndex = updatedAssignments.length - 1;

                // Clear vbKeyGo and vbKeyBack for the last assignment
                updatedAssignments[lastIndex] = {
                    ...updatedAssignments[lastIndex],
                    vbKeyGo: null,
                    vbKeyBack: null,
                    turnKey: null
                };
            }

            return updatedAssignments; // Set the modified assignments
        });

        setisNewTurn(false); // Reset the new turn state
        setIsReadySave(false);
    };

    const handleRemoveAssignment2 = index => {
        setVehicleAssignments(vehicleAssignments.filter((_, i) => i !== index));
        setisNewTurn(false);
        //validateTurn(vehicleAssignments); //มีปัญหา ลบแล้วยังจำ ค่าเดิม
    };

    // Update the value for a specific field in the list
    const handleAssignmentChange = (index, field, value) => {
        setIsReadySave(false);
        setAssignmentError("");
        const updatedAssignments = [...vehicleAssignments];

        // Update the specific field
        updatedAssignments[index][field] = value;

        if (field === "turnKey") {
            updatedAssignments[index]["vbKeyGo"] = null;
            updatedAssignments[index]["vbKeyBack"] = null;
            updatedAssignments[index]["startDatetime"] = null;
            updatedAssignments[index]["startTime"] = null;
            updatedAssignments[index]["endDatetime"] = null;
            updatedAssignments[index]["endTime"] = null;
            updatedAssignments[index]["arrStartTime"] = [];
            updatedAssignments[index]["arrEndTime"] = [];
        }

        // If the turnKey is 1, automatically set vbKeyBack to vbKeyGo
        if (field === "vbKeyGo" && updatedAssignments[index].turnKey === 1) {
            updatedAssignments[index]["vbKeyBack"] = (value || []).filter(booking => Number(booking.isOneWay) !== 1);
        }

        if (field === "vbKeyGo" || field === "vbKeyBack") {

            if (
                updatedAssignments[index]["vbKeyGo"] != null &&
                updatedAssignments[index]["vbKeyGo"].length > 0
            ) {
                const startDatetimeArray = updatedAssignments[index]["vbKeyGo"]
                    .map(item => new Date(item.startDatetime)) // Convert each startDatetime to a Date object
                    .sort((a, b) => a - b); // Sort the Date objects in ascending order

                updatedAssignments[index]["arrStartTime"] = arrTime.filter(
                    item =>
                        moment(
                            moment(startDatetimeArray[0]).format("YYYY-MM-DD") +
                            " " +
                            item.value
                        ) <= moment(startDatetimeArray[0])
                );

                updatedAssignments[index]["startDatetime"] = moment(startDatetimeArray[0]).format("YYYY-MM-DD");

                if (updatedAssignments[index].turnKey === 2)
                    updatedAssignments[index]["endDatetime"] = moment(startDatetimeArray[0]).format("YYYY-MM-DD");

            } 
            else {

                //updatedAssignments[index]["arrStartTime"] = [];
                //updatedAssignments[index]["startDatetime"] = null;
            }



            if (
                updatedAssignments[index]["vbKeyBack"] != null &&
                updatedAssignments[index]["vbKeyBack"].length > 0
            ) {

                const endDatetimeArray = updatedAssignments[index]["vbKeyBack"]
                    .map(item => new Date(item.endDatetime)) // Convert each startDatetime to a Date object
                    .sort((a, b) => b - a); // Sort the Date objects in ascending order

                updatedAssignments[index]["arrEndTime"] = arrTime.filter(
                    item =>
                        moment(moment(endDatetimeArray[0]).format("YYYY-MM-DD") + " " + item.value) >= moment(endDatetimeArray[0])
                );

                updatedAssignments[index]["endDatetime"] = moment(endDatetimeArray[0]).format("YYYY-MM-DD");
                
                if (updatedAssignments[index].turnKey === 3){
                    //updatedAssignments[index]["startDatetime"] = moment(endDatetimeArray[0]).format("YYYY-MM-DD");

                    updatedAssignments[index]["arrStartTime"] = arrTime.filter(
                        item =>
                            moment(
                                moment(endDatetimeArray[0]).format("YYYY-MM-DD") +
                                " " +
                                item.value
                            ) <= moment(endDatetimeArray[0])
                    );

                    updatedAssignments[index]["startDatetime"] = moment(endDatetimeArray[0]).format("YYYY-MM-DD");

                }





            } else {
                if (updatedAssignments[index].turnKey === 2) {
                    
                }
                else {
                    updatedAssignments[index]["endDatetime"] = null;
                    updatedAssignments[index]["arrEndTime"] = [];
                }

            }
        }



        if (field === "startTime" && updatedAssignments[index].turnKey === 2) {
            updatedAssignments[index]["arrEndTime"] = arrTime.filter(
                item =>
                    moment(moment(updatedAssignments[index]["endDatetime"]).format("YYYY-MM-DD") + " " + item.value) > moment(moment(updatedAssignments[index]["endDatetime"]).format("YYYY-MM-DD") + " " + updatedAssignments[index]["startTime"])
            );

            updatedAssignments[index]["vbKeyBack"] = [];
        }

        if (field === "endTime" && updatedAssignments[index].turnKey === 3) {
            updatedAssignments[index]["arrStartTime"] = arrTime.filter(
                item =>
                    moment(moment(updatedAssignments[index]["startDatetime"]).format("YYYY-MM-DD") + " " + item.value) < moment(moment(updatedAssignments[index]["startDatetime"]).format("YYYY-MM-DD") + " " + updatedAssignments[index]["endTime"])
            );
            updatedAssignments[index]["vbKeyGo"] = [];
        }

        setVehicleAssignments(updatedAssignments);
    };

    const handleSaveAssignments = async () => {
        if (savingAssignmentsRef.current || cancellingAssignmentRef.current) return;
        let payload;
        try {
            payload = buildVehicleAssignmentPayload(vehicleAssignments, selectedRows);
            assertAssignmentResources(vehicleAssignments[draftIndex], draftOptions, draftAvailability.ready, draftPassengers.requiredCapacity);
        } catch (error) {
            setAssignmentError(error.message);
            return;
        }
        savingAssignmentsRef.current = true;
        setSavingAssignments(true);
        setAssignmentError("");
        try {
            const response = await axios.post(host + "/api/v1/vehiclebooking/assignments", payload);
            if (response.data.result !== 200) throw new Error(response.data.msg || "ไม่สามารถบันทึกการจัดรถได้");
            setAssignmentSuccess(response.data.msg || "บันทึกการจัดรถเรียบร้อยแล้ว");
            handleClear();
        } catch (error) {
            if (error.response && error.response.status === 401) return;
            setAssignmentError(error.response?.data?.msg || error.response?.data?.message || error.message || "ไม่สามารถบันทึกการจัดรถได้ กรุณาลองใหม่");
            if (error.response?.status === 409) { setIsReadySave(false); draftAvailability.refresh(); }
        } finally {
            savingAssignmentsRef.current = false;
            setSavingAssignments(false);
        }
    };

    const getTurn = (vehicleAssignments) => {
        // Extract vbKeyGo and vbKeyBack counts separately
        const counts = vehicleAssignments.reduce((acc, assignment) => {
            // Handle vbKeyGo counts
            if (assignment.vbKeyGo != null) {
                assignment.vbKeyGo.forEach(item => {
                    const key = `${item.vbid}_${item.label}`;
                    if (!acc[key]) {
                        acc[key] = { vbid: item.vbid, label: item.label, countGo: 0, countBack: 0 };
                    }
                    acc[key].countGo += 1; // Increment countGo
                });
            }

            // Handle vbKeyBack counts
            if (assignment.vbKeyBack != null) {

                assignment.vbKeyBack.forEach(item => {
                    const key = `${item.vbid}_${item.label}`;
                    if (!acc[key]) {
                        acc[key] = { vbid: item.vbid, label: item.label, countGo: 0, countBack: 0 };
                    }
                    acc[key].countBack += 1; // Increment countBack
                });
            }


            return acc;
        }, {});

        // Convert the result object to an array for easier viewing
        const result = Object.values(counts);

        return result;
    };

    const checkTurnOver = (vehicleAssignments) => {
        var result = getTurn(vehicleAssignments);

        let updatedRowsGo = [...selectedRows]; // Start with the current selectedRows
        let updatedRowsBack = selectedRows.filter(booking => Number(booking.isOneWay) !== 1);

        result.forEach((i, index) => {
            //if (i.countGo == 1 && i.countBack == 1) {
            //    updatedRows = updatedRows.filter(row => row.vbid !== i.vbid);
            //}
            if (i.countGo == 1)
                updatedRowsGo = updatedRowsGo.filter(row => row.vbid !== i.vbid);

            if (i.countBack == 1)
                updatedRowsBack = updatedRowsBack.filter(row => row.vbid !== i.vbid);
        });
        return updatedRowsGo.length > 0 || updatedRowsBack.length;
    };

    const validateTurn = (vehicleAssignments) => {
        var result = getTurn(vehicleAssignments);

        var TotalGo = 0;
        var TotalBack = 0;

        let updatedRowsGo = [...selectedRows]; // Start with the current selectedRows
        let updatedRowsBack = selectedRows.filter(booking => Number(booking.isOneWay) !== 1);
        let updatedTurnType = [...ArrStillTurnType]; // Start with the current selectedRows

        //console.log(isNewTurn + " to " + vehicleAssignments.length+" record");


        result.forEach((i, index) => {

            TotalGo += i.countGo;
            TotalBack += i.countBack;

            //if (i.countGo == 1 && i.countBack == 1) {
            //    updatedRows = updatedRows.filter(row => row.vbid !== i.vbid);
            //}
            if (i.countGo == 1)
                updatedRowsGo = updatedRowsGo.filter(row => row.vbid !== i.vbid);

            if (i.countBack == 1)
                updatedRowsBack = updatedRowsBack.filter(row => row.vbid !== i.vbid);


        });

        setArrTurnGo(updatedRowsGo);

        setArrTurnBack(updatedRowsBack);

        //console.log("Go=" + TotalGo + " Back=" + TotalBack + " row =" + selectedRows.length);

        if (TotalGo == selectedRows.length) {
            updatedTurnType = updatedTurnType.filter(row => (row.value !== 1 && row.value !== 2));
        }

        if (TotalBack == selectedRows.filter(booking => Number(booking.isOneWay) !== 1).length) {
            updatedTurnType = updatedTurnType.filter(row => (row.value !== 1 && row.value !== 3));
        }

        if (updatedTurnType.length > 0) {
            setArrTurnType(updatedTurnType);
        }
        else { setArrTurnType([]); }
            
    };








    //----------------table function----------------
    //page order
    const handleRequestSort = property => {
        const isAsc = orderBy === property && orderDirection === "asc";
        setOrderDirection(isAsc ? "desc" : "asc");
        setOrderBy(property);
    };

    const sortedAssets = () => {
        return dataList.sort((a, b) => {
            if (orderDirection === "asc") {
                return a[orderBy] < b[orderBy] ? -1 : 1;
            }
            return a[orderBy] > b[orderBy] ? -1 : 1;
        });
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = event => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };
    //----------------table function----------------

    //เมื่อปิด Modal
    const handleCloseModal = () => {
        setModalOpen(false);
        setSelectedData(null);

        setIsEditing(false);
        setEditIndex(null);
    };

    //กดเพื่อแก้ไขข้อมูลเดิม  Edit Asset Click
    const handleEdit = (index, _data) => {
        console.log(_data);
        const dataToEdit = _data;
        setEditIndex(index);
        setIsEditing(true);

        setSelectedData(dataToEdit);

        setModalOpen(true);

        //fetchCatgory2(dataToEdit.typeKey); //active combobox level2 ใน modal

        //ใช้สำหรับ TSUser
        /*
            var _rEmployee = [];
            setEmployee(_rEmployee);
    
            setModalOpen(true);
    
            if (assetToEdit.userView !== null) {
                _rEmployee.push(assetToEdit.userView);
                setEmployee(_rEmployee)
                setExpanded(false)
            }
            else {
                setExpanded(true)
            }
            */
    };

    //กดเพื่อเพิ่มข้อมูลใหม่ Insert Asset Button Click
    const handleAdd = () => {
        clearForm();
        setModalOpen(true);
    };

    //Clear form input
    const clearForm = () => {
        var nullData = {
            code: null,
            name: null
        };

        setSelectedData(nullData);
    };

    const handleClear = () => {
        
        setVehicleAssignments([
            {
                startDatetime: null,
                startTime: null,
                endDatetime: null,
                endTime: null,
                turnKey: null,
                vehicleKey: null,
                vbKeyGo: [],
                vbKeyBack: [],
                arrStartTime: [],
                arrEndTime: []
            }
        ]);

        setVehicleAssignments2([
            {
                startDatetime: null,
                startTime: null,
                endDatetime: null,
                endTime: null,
                turnKey: null,
                vehicleKey: null,
                vbKeyGo: [],
                vbKeyBack: [],
                arrStartTime: [],
                arrEndTime: []
            }
        ]);

        setDisplayRequest([
            {
                vbid: null,
                value: null,
                endPlace: null,
                label: null,
                vbObjective: null,
                totalPassenger: 0,
                startDatetime: null,
                endDatetime: null,
                vehicleKey: null,
                driverKey: null,
                vehicleStartDatetime: null,
                vehicleEndDatetime: null
            }
        ]);

        setSelectedRows([]);
        setIsReadySave(false);
        setisNewTurn(false);
        setAssignmentError("");

        fetchDataList();
    };


    //on value change
    const handleInputChange = e => {
        const { name, value } = e.target;
        setSelectedData({ ...selectedData, [name]: value });
    };
    //on selected change
    const handleSelectChange = (name, value) => {
        setSelectedData({ ...selectedData, [name]: value });
    };

    //เมื่อเลือกเจ้าหน้าที่
    /*
      const handleEmployeeChange = (_val) => {
  
          setToggleEdit(false);
          setEmployee(_val)
  
          setSelectedData({ ...selectedData, ["userCode"]: _val[0].userName });
  
          setExpanded(false);
      }
      */

    const handleSaveChanges = async () => {
        try {
            console.log("/api/v1/asset/assettype/" + selectedData.typeKey);

            console.log(selectedData);
            if (isEditing) {
                await axios.put(
                    host + "/api/v1/asset/assettype/" + selectedData.typeKey,
                    selectedData
                );
            } else {
                await axios.post(host + "/api/v1/asset/assettype/", selectedData);
            }

            handleCloseModal();
            setIsEditing(false);
            setEditIndex(null);

            // Refresh the asset list after updating
            const response = await axios.get(
                host + "/api/v1/asset/assettype?name=" + Keyword
            );
            setDataList(response.data.data);
        } catch (error) {
            console.error("Error updating data:", error);
        }
    };

    const handleHoliday = txt => {
        setHolidayText(txt);
        setModalHoliday(true);
    };

    function isDateValid(e, selectedDate) {
        return e > new Date().setDate(new Date().getDate() - 1);
    }

    const assignmentStatuses = {
        pending: { label: "ยังไม่ได้จัดรถ", color: "#616161" },
        partial: { label: "จัดรถบางเที่ยว", color: "#b26a00" },
        assigned: { label: "จัดรถแล้ว", color: "#2e7d32" },
        cancelled: { label: "ยกเลิกคำขอ", color: "#b71c1c" }
    };
    const formatAssignedTime = value => value && moment(value).isValid()
        ? moment(value).format("DD/MM/BBBB HH:mm") : "-";
    const renderRequestedPeriod = booking => {
        const start = moment(booking.startDatetime || null);
        const end = moment(booking.endDatetime || null);
        if (Number(booking.isOneWay) === 1) return <>
            <div style={{ whiteSpace: "nowrap" }}>{start.isValid() ? start.format("DD/MM/BBBB") : "-"}</div>
            <div style={{ whiteSpace: "nowrap" }}>ขาไป: {start.isValid() ? start.format("HH:mm") : "-"}</div>
            <div style={{ color: "#075985" }}>เที่ยวเดียว</div>
        </>;
        if (start.isValid() && end.isValid() && start.isSame(end, "day")) {
            return <>
                <div style={{ whiteSpace: "nowrap" }}>{start.format("DD/MM/BBBB")}</div>
                <div style={{ whiteSpace: "nowrap" }}>ขาไป: {start.format("HH:mm")}</div>
                <div style={{ whiteSpace: "nowrap" }}>ขากลับ: {end.format("HH:mm")}</div>
            </>;
        }
        return <>
            <div style={{ whiteSpace: "nowrap" }}>ไป: {formatAssignedTime(booking.startDatetime)}</div>
            <div style={{ whiteSpace: "nowrap" }}>กลับ: {formatAssignedTime(booking.endDatetime)}</div>
        </>;
    };
    const renderAssignedLegs = (legs, field, direction, canEdit) => legs?.length ? legs.map((leg, index) => (
        <div key={`${leg.assignmentTurnID}-${index}`} style={{ marginBottom: 8 }}>
            <strong>{leg.vehicleName || `รถ ${leg.vehicleKey}`}</strong>
            {leg.licensePlate && <Typography variant="caption" component="div" color="textSecondary">{leg.licensePlate}</Typography>}
            <Typography variant="body2" style={{ whiteSpace: "nowrap" }}>{formatAssignedTime(leg[field])}</Typography>
            <Typography variant="body2">ผู้ขับ: {leg.driverName || leg.driverUserName || "ยังไม่ระบุ"}</Typography>
            {canEdit && leg.assignmentTurnID && <Button size="small" color="primary" disabled={savingAssignments || cancellingAssignment}
                aria-label={`แก้ไขเที่ยว${direction} ${leg.vehicleName || leg.vehicleKey}`}
                onClick={() => setEditingTurn({ turnId: leg.assignmentTurnID, goBackKey: direction === "ขาไป" ? 1 : 2 })}>
                แก้ไขเที่ยว{direction}
            </Button>}
        </div>
    )) : "-";
    const renderCancellationButtons = booking => {
        const groups = new Map();
        for (const [direction, legs] of [["ขาไป", booking.outboundAssignments], ["ขากลับ", booking.returnAssignments]]) {
            for (const leg of legs || []) {
                if (!leg.assignmentID) continue;
                if (!groups.has(leg.assignmentID)) groups.set(leg.assignmentID, { assignmentID: leg.assignmentID, directions: new Set() });
                groups.get(leg.assignmentID).directions.add(direction);
            }
        }
        if (!groups.size) return null;
        return <div>{Array.from(groups.values()).map(group => (
            <Button key={group.assignmentID} size="small" color="secondary" disabled={savingAssignments || cancellingAssignment}
                aria-label={`ยกเลิกการจัดรถ ${booking.vbObjective || booking.endPlace} ${Array.from(group.directions).join(" / ")}`}
                onClick={() => setCancelTarget({ assignmentID: group.assignmentID })}>
                ยกเลิกการจัดรถ{groups.size > 1 ? ` (${Array.from(group.directions).join(" / ")})` : ""}
            </Button>
        ))}</div>;
    };
    const renderDispatchers = booking => {
        const directions = [
            { label: "ขาไป", legs: booking.outboundAssignments || [] },
            { label: "ขากลับ", legs: booking.returnAssignments || [] }
        ];
        if (!directions.some(direction => direction.legs.length)) return "-";
        return directions.map(direction => direction.legs.map((leg, index) => (
            <div key={`${direction.label}-${leg.assignmentTurnID}-${index}`}>
                {direction.label}: {leg.assignedByName || leg.assignedBy || "-"}
                {leg.assignedByName && leg.assignedBy && leg.assignedByName !== leg.assignedBy && ` (${leg.assignedBy})`}
                {leg.assignedAt && <Typography variant="caption" component="div" color="textSecondary">จัดเมื่อ {formatAssignedTime(leg.assignedAt)}</Typography>}
            </div>
        )));
    };

    return (
        <div>
            {assignmentError && <Typography role="alert" color="error" style={{ marginBottom: 16 }}>{assignmentError}</Typography>}
            {assignmentSuccess && <Typography role="status" style={{ color: "green", marginBottom: 16 }}>{assignmentSuccess}</Typography>}
            {(!displayRequest?.length || displayRequest[0].vbid == null) ?
            <Grid>
                <Col xs={12} sm={12} md={12}>
                    <Card>
                        <CardHeader color="primary">
                            <h4 className={classes.cardTitleWhite}>รายการขอใช้รถประจำวัน</h4>
                            <p className={classes.cardCategoryWhite}></p>
                        </CardHeader>
                        <CardBody>
                            <div>
                                <Grid>
                                    <Col xs={12} sm={12} md={12}>
                                        <Label>วันที่ขอใช้</Label>
                                        <FormGroup
                                            style={{ padding: "0 0px", marginBottom: "10px" }}
                                            className={"input-lg"}
                                        >
                                            <i
                                                className="far fa-calendar-check fa-2x"
                                                style={{
                                                    position: "absolute",
                                                    left: "30px",
                                                    zIndex: 1
                                                }}
                                            ></i>
                                            <Datetime
                                                value={
                                                    moment(StartDatetime).isValid()
                                                        ? moment(StartDatetime)
                                                        : null
                                                }
                                                renderYear={function (props, year, selectedDate) {
                                                    return <td {...props}>{year + 543}</td>;
                                                }}
                                                isValidDate={isDateValid}
                                                inputProps={{
                                                    name: "StartDatetime",
                                                    placeholder: "วันที่เดินทาง",
                                                    readOnly: "readonly",
                                                    style: {
                                                        fontSize: "1.2em",
                                                        borderRadius: 0,
                                                        paddingLeft: "50px",
                                                        cursor: "pointer",
                                                        background: "#ffffff",
                                                        color: "#000000"
                                                    }
                                                }}
                                                closeOnSelect={true}
                                                closeOnTab={true}
                                                dateFormat="D MMMM BBBB"
                                                timeFormat={false}
                                                onChange={e => setStartDatetime(e.format("YYYY-MM-DD"))}
                                            />
                                        </FormGroup>
                                    </Col>
                                    {/* //Combobox Filter
                                   <Col xs={12} sm={12} md={6}>
                                        <TSSelect2 isClearable={true} label="TypeKey" options={ArrAssetType} value={TypeKey} onChange={e => setTypeKey(e != null ? e.value : '') } />
                                    </Col> 
                                    */}
                                </Grid>

                                {/* Add more fields as necessary for other properties */}  
                                <TableContainer
                                    component={Paper}
                                    className={classes.tableContainer}
                                >
                                    <Table className={classes.table} aria-label="data table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell padding="checkbox">เลือก</TableCell>
                                                <TableCell>
                                                    <TableSortLabel
                                                        active={orderBy === "vbObjective"}
                                                        direction={
                                                            orderBy === "vbObjective" ? orderDirection : "asc"
                                                        }
                                                        onClick={() => handleRequestSort("vbObjective")}
                                                    >
                                                        วัตถุประสงค์{tableText}
                                                    </TableSortLabel>
                                                </TableCell>
                                                <TableCell>
                                                    <TableSortLabel
                                                        active={orderBy === "endPlace"}
                                                        direction={
                                                            orderBy === "endPlace" ? orderDirection : "asc"
                                                        }
                                                        onClick={() => handleRequestSort("endPlace")}
                                                    >
                                                        ต้นทาง → ปลายทาง
                                                    </TableSortLabel>
                                                </TableCell>
                                                <TableCell>
                                                    <TableSortLabel
                                                        active={orderBy === "startDatetime"}
                                                        direction={
                                                            orderBy === "startDatetime"
                                                                ? orderDirection
                                                                : "asc"
                                                        }
                                                        onClick={() => handleRequestSort("startDatetime")}
                                                    >
                                                        วันเวลาที่ขอใช้
                                                    </TableSortLabel>
                                                </TableCell>
                                                <TableCell align="center">
                                                    <TableSortLabel
                                                        active={orderBy === "totalPassenger"}
                                                        direction={
                                                            orderBy === "totalPassenger"
                                                                ? orderDirection
                                                                : "asc"
                                                        }
                                                        onClick={() => handleRequestSort("totalPassenger")}
                                                    >
                                                        ผู้โดยสาร
                                                    </TableSortLabel>
                                                </TableCell>
                                                <TableCell>สถานะการจัดรถ</TableCell>
                                                <TableCell>ขาไป: รถ / เวลาออกรถ / ผู้ขับ</TableCell>
                                                <TableCell>ขากลับ: รถ / เวลากลับ / ผู้ขับ</TableCell>
                                                <TableCell>ผู้จัดรถ</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {//dataList.map((asset, index) => (
                                                sortedAssets()
                                                    .slice(
                                                        page * rowsPerPage,
                                                        page * rowsPerPage + rowsPerPage
                                                    )
                                                    .map((data, index) => (
                                                        <TableRow key={index} className={classes.tableRow}>
                                                            <TableCell padding="checkbox">
                                                                <Checkbox
                                                                    checked={selectedRows.includes(data.vbid)} // Assuming `data.id` is the unique key for each row
                                                                    disabled={!data.canAssign || cancellingAssignment}
                                                                    inputProps={{ "aria-label": `เลือกคำขอ ${data.vbObjective || data.endPlace}` }}
                                                                    onChange={() => handleSelectRow(data.vbid)}
                                                                />
                                                            </TableCell>
                                                            <TableCell className={classes.tableCell}>
                                                                <Button
                                                                    style={{ textDecoration: "underline" }}
                                                                    onClick={() => handleEdit(index, data)}
                                                                >
                                                                    {data.vbObjective}
                                                                </Button>

                                                            </TableCell>
                                                            <TableCell className={classes.tableCell}>
                                                                {data.startPlace || "-"} <br/> ↓ <br/> {data.endPlace || "-"}
                                                            </TableCell>
                                                            <TableCell className={classes.tableCell}>
                                                                {renderRequestedPeriod(data)}
                                                            </TableCell>
                                                            <TableCell className={classes.tableCell} align="center">
                                                                <Tooltip
                                                                    title={
                                                                        data.passengerNames && data.passengerNames.length > 0
                                                                            ? `ผู้โดยสาร: ${data.passengerNames.join(", ")}`
                                                                            : `ผู้โดยสาร: ${data.totalPassenger ?? 0} คน`
                                                                    }
                                                                >
                                                                    <Chip
                                                                        size="small"
                                                                        icon={<i className="fa fa-users" style={{ fontSize: "0.8rem", marginLeft: 6, color: "#166534" }}></i>}
                                                                        label={`${data.totalPassenger ?? 0} คน`}
                                                                        style={{
                                                                            backgroundColor: "#e8f5e9",
                                                                            color: "#166534",
                                                                            fontWeight: 700,
                                                                            fontSize: "0.85rem",
                                                                            border: "1px solid #c8e6c9",
                                                                            cursor: "pointer"
                                                                        }}
                                                                    />
                                                                </Tooltip>
                                                            </TableCell>
                                                            <TableCell className={classes.tableCell}>
                                                                <Chip size="small" label={(assignmentStatuses[data.assignmentStatus] || assignmentStatuses.pending).label}
                                                                    style={{ color: "white", backgroundColor: (assignmentStatuses[data.assignmentStatus] || assignmentStatuses.pending).color }} />
                                                                {renderCancellationButtons(data)}
                                                            </TableCell>
                                                            <TableCell className={classes.tableCell}>{renderAssignedLegs(data.outboundAssignments, "startDatetime", "ขาไป", data.assignmentStatus !== "cancelled")}</TableCell>
                                                            <TableCell className={classes.tableCell}>{Number(data.isOneWay) === 1 ? "เที่ยวเดียว" : renderAssignedLegs(data.returnAssignments, "endDatetime", "ขากลับ", data.assignmentStatus !== "cancelled")}</TableCell>
                                                            <TableCell className={classes.tableCell}>{renderDispatchers(data)}</TableCell>
                                                            {/*<TableCell className={classes.tableCell} style={{ color: (data.assetStatusKey != null && ArrAssetStatus.find(t => t.value == data.assetStatusKey) != null) ? ArrAssetStatus.find(t => t.value == data.assetStatusKey).color : 'black' }} >{(data.assetStatusKey != null && ArrAssetStatus.find(t => t.value == data.assetStatusKey) != null) ? ArrAssetStatus.find(t => t.value == data.assetStatusKey).label : ''}</TableCell>*/}
                                                        </TableRow>
                                                    ))}
                                        </TableBody>
                                        <TableFooter>
                                            <TableRow>
                                                <TablePagination
                                                    colSpan={9}
                                                    rowsPerPageOptions={[5, 10, 25]}
                                                    count={dataList.length}
                                                    rowsPerPage={rowsPerPage}
                                                    page={page}
                                                    onPageChange={handleChangePage}
                                                    onRowsPerPageChange={handleChangeRowsPerPage}
                                                />
                                            </TableRow>
                                        </TableFooter>
                                    </Table>
                                </TableContainer>
                                
                            </div>
                        </CardBody>
                        <CardFooter>
                            <Col xs={12} sm={12} md={12}>
                                    <Button2
                                        color="primary"
                                        onClick={handleGenerateJSON}
                                        disabled={selectedRows.length === 0 || cancellingAssignment} // Disable if no rows are selected
                                    >
                                         <h4>
                                            <i className={"fa fa-car"}> จัดคิวรถ</i>
                                        </h4>
                                    </Button2>

                                    <Button2 color="success" type="button" onClick={handleAdd} hidden>
                                        <h4>
                                            <i className={"fa fa-plus"}> เพิ่ม{tableText}</i>
                                        </h4>
                                    </Button2>
                            </Col>
                            <Modal isOpen={modalOpen} toggle={handleCloseModal}>
                                <ModalHeader toggle={handleCloseModal}></ModalHeader>
                                <ModalBody>
                                    {selectedData && (
                                        <Card>
                                            {isEditing ? (
                                                <CardHeader color="primary">
                                                    <h4 className={classes.cardTitleWhite}>
                                                        {selectedData.name}
                                                    </h4>
                                                    <p className={classes.cardCategoryWhite}>
                                                        {selectedData.docNo}
                                                    </p>
                                                </CardHeader>
                                            ) : (
                                                <CardHeader color="primary">
                                                    <h4 className={classes.cardTitleWhite}>
                                                        เพิ่ม{tableText}
                                                    </h4>
                                                    <p className={classes.cardCategoryWhite}></p>
                                                </CardHeader>
                                            )}
                                            <CardBody>
                                                <Grid>
                                                    <Col xs={12} sm={12} md={12}>
                                                        <TSText
                                                            icon="far fa-edit"
                                                            label="ต้นทาง"
                                                            value={selectedData.startPlace}
                                                            readOnly
                                                        />
                                                    </Col>
                                                    <Col xs={12} sm={12} md={12}>
                                                        <TSText
                                                            icon="far fa-edit"
                                                            label="ปลายทาง"
                                                            value={selectedData.endPlace}
                                                            readOnly
                                                        />
                                                    </Col>
                                                    <Col xs={12} sm={12} md={12}>
                                                        <TSText
                                                            icon="far fa-user"
                                                            label="จำนวนผู้โดยสาร"
                                                            value={`${selectedData.totalPassenger || 0} คน${selectedData.passengerNames && selectedData.passengerNames.length > 0 ? ` (${selectedData.passengerNames.join(", ")})` : ""}`}
                                                            readOnly
                                                        />
                                                    </Col>

                                                    {/* //Input Combobox
                                                <Col xs={12} sm={6} md={6}>
                                                    <TSSelect2 name="typeKey" label="ประเภทครุภัณฑ์" options={ArrAssetType} value={selectedData.typeKey ?? ''} onChange={e => handleSelectChange('typeKey', (e != null ? e.value : '')) } />
                                                </Col>
                                                */}

                                                    <Col
                                                        xs={12}
                                                        sm={12}
                                                        md={12}
                                                        style={{ marginTop: "20px" }}
                                                    >
                                                        <Label>
                                                            ผู้บันทึก: {selectedData.creatorCode}{" "}
                                                            {selectedData.createDatetime}
                                                        </Label>
                                                    </Col>
                                                    <Col xs={12} sm={12} md={12}>
                                                        <Label>
                                                            แก้ไขล่าสุด: {selectedData.lastEditerCode}{" "}
                                                            {selectedData.lastEditDatetime}
                                                        </Label>
                                                    </Col>
                                                </Grid>
                                            </CardBody>
                                            <CardFooter></CardFooter>
                                        </Card>
                                    )}
                                </ModalBody>
                                <div className="modal-footer">
                                    {/*
                                        <Button2
                                        color="info"
                                        type="button"
                                        onClick={handleSaveChanges}
                                        style={{ marginRight: '50px' }}
                                    >
                                        <h4>บันทึก</h4>
                                    </Button2>

                                    <Button2
                                        color="danger"
                                        type="button"
                                        onClick={handleCloseModal}
                                    >
                                        <h4>ยกเลิก</h4>
                                    </Button2>
                                    */}
                                </div>
                            </Modal>

                            {/* Confirm */}
                            <Modal toggle={() => setModal(false)} isOpen={modal}>
                                <div className="modal-header justify-content-center">
                                    <div>
                                        <i
                                            className={icon}
                                            style={{ color: "blue", fontSize: "2em" }}
                                        ></i>
                                    </div>
                                </div>
                                <ModalBody>
                                    <p
                                        style={{
                                            textAlign: "center",
                                            fontSize: "1.8em"
                                        }}
                                    >
                                        {icon !== "fa fa-spinner fa-w-16 fa-spin fa-lg"
                                            ? "ยืนยันการบันทึกข้อมูล"
                                            : "กำลังตรวจสอบข้อมูล"}
                                    </p>
                                    <p> </p>
                                </ModalBody>
                                <div className="modal-footer">
                                    <Button
                                        color="success"
                                        type="button"
                                        //onClick={handleConfirm}
                                        disabled={icon === "fa fa-spinner fa-w-16 fa-spin fa-lg"}
                                    >
                                        <i
                                            className={"fa fa-thumbs-up"}
                                            style={{ fontSize: "1.8em", padding: "0 5px 5px 0" }}
                                        ></i>
                                        <h4>ยืนยัน</h4>
                                    </Button>

                                    <Button
                                        color="danger"
                                        type="button"
                                        onClick={() => {
                                            setIcon("far fa-question-circle");
                                            setModal(false);
                                        }}
                                    >
                                        <i
                                            className={"fa fa-thumbs-down"}
                                            style={{ fontSize: "1.8em", padding: "0 5px 5px 0" }}
                                        ></i>
                                        <h4>ยกเลิก</h4>
                                    </Button>
                                </div>
                            </Modal>
                        </CardFooter>
                    </Card>
                </Col>
            </Grid>
            : 
            
            <>                          
            <Grid>
                <Col xs={12} sm={12} md={12}>
                    <Card>
                        <CardHeader color="primary">
                            <h4 className={classes.cardTitleWhite}>รายการที่ต้องการจัดเที่ยวรถ</h4>
                            <p className={classes.cardCategoryWhite}></p>
                        </CardHeader>
                        <CardBody>
                            <div>
                             <Table className={classes.table} aria-label="data table">
                                            <TableHead>
                                                <TableRow>
    
                                                    <TableCell>
                                                        ต้นทาง → ปลายทาง
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        ผู้โดยสาร
                                                    </TableCell>
                                                    <TableCell>
                                                        เที่ยวรถขาไป
                                                    </TableCell>
                                                    <TableCell>
                                                        เที่ยวรถขากลับ
                                                    </TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {//dataList.map((asset, index) => (
                                                    displayRequest
                                                    .map((data, index) => (
                                                            <TableRow key={index} className={classes.tableRow}>
                                                                <TableCell className={classes.tableCell}>
                                                                    <Col>
                                                                        <Row>
                                                                            {data.startPlace || "-"} → {data.endPlace || "-"}
                                                                            ( {moment(data.startDatetime).format("DD/MM/BBBB HH:mm") +
                                                                                (Number(data.isOneWay) === 1 ? " น. • เที่ยวเดียว" : " - " + moment(data.endDatetime).format("HH:mm น."))})
                                                                        </Row>  
                                                                        <Row>{data.vbObjective}</Row>
                                                                    </Col>
                                                                </TableCell>
                                                                <TableCell className={classes.tableCell} align="center">
                                                                    <Chip
                                                                        size="small"
                                                                        icon={<i className="fa fa-users" style={{ fontSize: "0.8rem", marginLeft: 6, color: "#166534" }}></i>}
                                                                        label={`${data.totalPassenger || 0} คน`}
                                                                        style={{
                                                                            backgroundColor: "#e8f5e9",
                                                                            color: "#166534",
                                                                            fontWeight: 700,
                                                                            fontSize: "0.85rem",
                                                                            border: "1px solid #c8e6c9"
                                                                        }}
                                                                    />
                                                                </TableCell>
                                                                <TableCell className={classes.tableCell}>
                                                                    <Col>
                                                                        <Row>
                                                                            {data.vehicleStartDatetime && moment(data.vehicleStartDatetime).isValid() && (
                                                                            <>{moment(data.vehicleStartDatetime).format("HH:mm")}</>
                                                                            )}
                                                                        </Row>
                                                                        <Row>ผู้ขับ: {draftAvailability.data?.drivers.find(driver => driver.userName === data.goDriverUserName)?.fullName || data.goDriverUserName || "-"}</Row>
                                                                        <Row>{(data.goVehicleKey != null && ArrVehicle.find(t => t.value == data.goVehicleKey) != null) ? ArrVehicle.find(t => t.value == data.goVehicleKey).label : ''}</Row>
                                                                    </Col>
                                                                </TableCell>
                                                                <TableCell className={classes.tableCell}>
                                                                    {Number(data.isOneWay) === 1 ? "เที่ยวเดียว" : <Col>
                                                                        <Row>
                                                                            {data.vehicleEndDatetime && moment(data.vehicleEndDatetime).isValid() && (
                                                                            <>{moment(data.vehicleEndDatetime).format("HH:mm")}</>
                                                                            )}
                                                                        </Row>
                                                                        <Row>ผู้ขับ: {draftAvailability.data?.drivers.find(driver => driver.userName === data.backDriverUserName)?.fullName || data.backDriverUserName || "-"}</Row>
                                                                        <Row>{(data.backVehicleKey != null && ArrVehicle.find(t => t.value == data.backVehicleKey) != null) ? ArrVehicle.find(t => t.value == data.backVehicleKey).label : ''}</Row>
                                                                    </Col>}
                                                                </TableCell>                                   
                                                                {/*<TableCell className={classes.tableCell} style={{ color: (data.assetStatusKey != null && ArrAssetStatus.find(t => t.value == data.assetStatusKey) != null) ? ArrAssetStatus.find(t => t.value == data.assetStatusKey).color : 'black' }} >{(data.assetStatusKey != null && ArrAssetStatus.find(t => t.value == data.assetStatusKey) != null) ? ArrAssetStatus.find(t => t.value == data.assetStatusKey).label : ''}</TableCell>*/}
                                                            </TableRow>
                                                        ))}
                                            </TableBody>
                                        </Table>
                            </div>
                        </CardBody>
                        <CardFooter>
                        </CardFooter>
                    </Card>
                </Col>
            </Grid>

            <Grid>
                <Col xs={12} sm={12} md={12}>
                    {vehicleAssignments.map((assignment, index) => {
                        const isLast = (index === vehicleAssignments.length - 1); // Check if this is the last item
                        const { goPassengers, backPassengers, requiredCapacity } = calculateTurnPassengers(assignment);
                        const resourceOptions = assignmentResourceOptions(draftAvailability.data, assignment, vehicleAssignments, index, requiredCapacity);

                        const availableTurnTypes = (isLast && vehicleAssignments.length > 1)
                            ? ArrTurnType // Apply any filtering condition here
                            : ArrStillTurnType; // Use full list if not last item
                        const filteredArrTurnType = selectedRows.every(booking => Number(booking.isOneWay) === 1)
                            ? availableTurnTypes.filter(type => type.value === 2) : availableTurnTypes;

                        return (
                            <Card key={index}
                                style={!isLast ?
                                    { background: 'linear-gradient(to right, #d3d3d3, #a9a9a9)', opacity: 0.6 } : null
                                }>
                                <CardHeader
                                    color="primary"
                                    style={{ display: "flex", justifyContent: "space-between", alignItems: "center", height: '50px' }}
                                >
                                    <h4 className={classes.cardTitleWhite}>รายการ{tableText}</h4>
                                    {index != 0 ?
                                        <IconButton disabled={savingAssignments} onClick={() => handleRemoveAssignment(index)}>
                                            <i className="fa fa-trash" style={{ color: "white" }}></i>
                                        </IconButton> : <></>
                                    }
                                </CardHeader>

                                {/* Disable CardBody contents if it's not the last item */}
                                <CardBody className={isLast ? '' : 'disabled-cardbody'}>
                                    {Array.from(new Map([...(assignment.vbKeyGo || []), ...(assignment.vbKeyBack || [])].map(booking => [booking.vbid, booking])).values()).map(booking => (
                                        <Typography key={booking.vbid} style={{ marginBottom: 8 }}>{booking.startPlace || "-"} → {booking.endPlace || "-"}{Number(booking.isOneWay) === 1 ? " (เที่ยวเดียว)" : ""}</Typography>
                                    ))}
                                    <fieldset style={{ pointerEvents: isLast && !savingAssignments ? 'auto' : 'none' }} disabled={!isLast || savingAssignments}>
                                        <Row>
                                            <Col xs={12}>
                                                <TSSelect2
                                                    label="ประเภทเที่ยว"
                                                    style={{ zIndex: 10 }}
                                                    options={filteredArrTurnType}
                                                    value={assignment.turnKey}
                                                    onChange={e =>
                                                        handleAssignmentChange(index, "turnKey", e.value)
                                                    }
                                                />
                                            </Col>

                                            {/* Conditional rendering based on turnKey */}
                                            {assignment.turnKey === 1 && (
                                                <>
                                                    <Col xs={12} sm={12} md={6}>
                                                        <TSSelectMultiple
                                                            label="ผู้ขอขาไป"
                                                            options={arrTurnGo}
                                                            value={assignment.vbKeyGo}
                                                            onChange={e =>
                                                                handleAssignmentChange(index, "vbKeyGo", e)
                                                            }
                                                        />
                                                        <div style={{ marginTop: -4, marginBottom: 12, fontSize: "0.9rem", color: "#1b5e20", fontWeight: 600 }}>
                                                            <i className="fa fa-users" style={{ marginRight: 6 }}></i>
                                                            จำนวนผู้โดยสารขาไป: <strong>{goPassengers}</strong> คน
                                                            {(assignment.vbKeyGo || []).length > 1 && (
                                                                <span style={{ color: "#555", fontWeight: "normal", marginLeft: 6 }}>
                                                                    (รวม {(assignment.vbKeyGo || []).length} รายการ)
                                                                </span>
                                                            )}
                                                        </div>
                                                    </Col>
                                                    <Col xs={12} sm={12} md={6}>
                                                        <TSSelectMultiple
                                                            label="ผู้ขอขากลับ"
                                                            options={arrTurnBack}
                                                            value={assignment.vbKeyBack}
                                                            onChange={e =>
                                                                handleAssignmentChange(index, "vbKeyBack", e)
                                                            }
                                                        />
                                                        <div style={{ marginTop: -4, marginBottom: 12, fontSize: "0.9rem", color: "#0d47a1", fontWeight: 600 }}>
                                                            <i className="fa fa-users" style={{ marginRight: 6 }}></i>
                                                            จำนวนผู้โดยสารขากลับ: <strong>{backPassengers}</strong> คน
                                                            {(assignment.vbKeyBack || []).length > 1 && (
                                                                <span style={{ color: "#555", fontWeight: "normal", marginLeft: 6 }}>
                                                                    (รวม {(assignment.vbKeyBack || []).length} รายการ)
                                                                </span>
                                                            )}
                                                        </div>
                                                    </Col>
                                                </>
                                            )}

                                            {assignment.turnKey === 2 && (
                                                <Col xs={12} sm={12} md={12}>
                                                    <TSSelectMultiple
                                                        label="ผู้ขอขาไป"
                                                        options={arrTurnGo}
                                                        value={assignment.vbKeyGo}
                                                        onChange={e =>
                                                            handleAssignmentChange(index, "vbKeyGo", e)
                                                        }
                                                    />
                                                    <div style={{ marginTop: -4, marginBottom: 12, fontSize: "0.9rem", color: "#1b5e20", fontWeight: 600 }}>
                                                        <i className="fa fa-users" style={{ marginRight: 6 }}></i>
                                                        จำนวนผู้โดยสารขาไป: <strong>{goPassengers}</strong> คน
                                                        {(assignment.vbKeyGo || []).length > 1 && (
                                                            <span style={{ color: "#555", fontWeight: "normal", marginLeft: 6 }}>
                                                                (รวม {(assignment.vbKeyGo || []).length} รายการ)
                                                            </span>
                                                        )}
                                                    </div>
                                                </Col>
                                            )}

                                            {assignment.turnKey === 3 && (
                                                <Col xs={12} sm={12} md={12}>
                                                    <TSSelectMultiple
                                                        label="ผู้ขอขากลับ"
                                                        options={arrTurnBack}
                                                        value={assignment.vbKeyBack}
                                                        onChange={e =>
                                                            handleAssignmentChange(index, "vbKeyBack", e)
                                                        }
                                                    />
                                                    <div style={{ marginTop: -4, marginBottom: 12, fontSize: "0.9rem", color: "#0d47a1", fontWeight: 600 }}>
                                                        <i className="fa fa-users" style={{ marginRight: 6 }}></i>
                                                        จำนวนผู้โดยสารขากลับ: <strong>{backPassengers}</strong> คน
                                                        {(assignment.vbKeyBack || []).length > 1 && (
                                                            <span style={{ color: "#555", fontWeight: "normal", marginLeft: 6 }}>
                                                                (รวม {(assignment.vbKeyBack || []).length} รายการ)
                                                            </span>
                                                        )}
                                                    </div>
                                                </Col>
                                            )}

                                            <Col xs={12} sm={6} md={4}>
                                                <Label>วันที่เริ่มต้น</Label>
                                                <FormGroup
                                                    style={{ padding: "0 0px", marginBottom: "10px" }}
                                                    className={"input-lg"}
                                                >
                                                    <i
                                                        className="far fa-calendar-check fa-2x"
                                                        style={{
                                                            position: "absolute",
                                                            left: "30px",
                                                            zIndex: 1
                                                        }}
                                                    ></i>
                                                    <Datetime
                                                        value={
                                                            moment(assignment.startDatetime).isValid()
                                                                ? moment(assignment.startDatetime)
                                                                : null
                                                        }
                                                        renderYear={function (props, year, selectedDate) {
                                                            return <td {...props}>{year + 543}</td>;
                                                        }}
                                                        isValidDate={isDateValid}
                                                        inputProps={{
                                                            name: "StartDatetime",
                                                            placeholder: "วันที่เริ่มต้น",
                                                            readOnly: "readonly",
                                                            style: {
                                                                fontSize: "1.2em",
                                                                borderRadius: 0,
                                                                paddingLeft: "50px",
                                                                cursor: "pointer",
                                                                background: "#ffffff",
                                                                color: "#000000"
                                                            }
                                                        }}
                                                        closeOnSelect={true}
                                                        closeOnTab={true}
                                                        dateFormat="D MMMM BBBB"
                                                        timeFormat={false}
                                                        onChange={e =>
                                                            handleAssignmentChange(
                                                                index,
                                                                "startDatetime",
                                                                e.format("YYYY-MM-DD")
                                                            )
                                                        }
                                                    />
                                                </FormGroup>
                                            </Col>
                                            <Col xs={12} sm={6} md={2}>
                                                <TSSelect2
                                                    label="เวลาออกรถ"
                                                    options={assignment.arrStartTime}
                                                    value={assignment.startTime}
                                                    onChange={e =>
                                                        handleAssignmentChange(index, "startTime", e.value)
                                                    }
                                                />
                                            </Col>
                                            <Col xs={12} sm={6} md={4}>
                                                <Label>ถึงวันที่</Label>
                                                <FormGroup
                                                    style={{ padding: "0 0px", marginBottom: "10px" }}
                                                    className={"input-lg"}
                                                >
                                                    <i
                                                        className="far fa-calendar-check fa-2x"
                                                        style={{
                                                            position: "absolute",
                                                            left: "30px",
                                                            zIndex: 1
                                                        }}
                                                    ></i>
                                                    <Datetime
                                                        value={
                                                            moment(assignment.endDatetime).isValid()
                                                                ? moment(assignment.endDatetime)
                                                                : null
                                                        }
                                                        renderYear={function (props, year, selectedDate) {
                                                            return <td {...props}>{year + 543}</td>;
                                                        }}
                                                        isValidDate={isDateValid}
                                                        inputProps={{
                                                            name: "EndDatetime",
                                                            placeholder: "ถึงวันที่",
                                                            readOnly: "readonly",
                                                            style: {
                                                                fontSize: "1.2em",
                                                                borderRadius: 0,
                                                                paddingLeft: "50px",
                                                                cursor: "pointer",
                                                                background: "#ffffff",
                                                                color: "#000000"
                                                            }
                                                        }}
                                                        closeOnSelect={true}
                                                        closeOnTab={true}
                                                        dateFormat="D MMMM BBBB"
                                                        timeFormat={false}
                                                        onChange={e =>
                                                            handleAssignmentChange(
                                                                index,
                                                                "endDatetime",
                                                                e.format("YYYY-MM-DD")
                                                            )
                                                        }
                                                    />
                                                </FormGroup>
                                            </Col>
                                            <Col xs={12} sm={6} md={2}>
                                                <TSSelect2
                                                    label={assignment.turnKey === 2 ? "เวลาสิ้นสุดเที่ยว" : "เวลารับกลับ"}
                                                    options={assignment.arrEndTime}
                                                    value={assignment.endTime}
                                                    onChange={e =>
                                                        handleAssignmentChange(index, "endTime", e.value)
                                                    }
                                                />
                                            </Col>
                                        </Row>
                                        {isLast && <Row>
                                            <Col xs={12}>
                                                {!draftAvailability.rangeValid && <Typography color="textSecondary">ระบุวันและเวลาให้ครบก่อนเลือกรถและผู้ขับ</Typography>}
                                                {draftAvailability.loading && <Typography>กำลังตรวจสอบรถและผู้ขับ...</Typography>}
                                                {draftAvailability.error && <Typography role="alert" color="error">{draftAvailability.error}</Typography>}
                                                {draftAvailability.error && <Button onClick={draftAvailability.refresh}>ตรวจสอบอีกครั้ง</Button>}
                                                {draftAvailability.ready && !resourceOptions.drivers.length && <Typography color="error">ยังไม่มีคนขับที่พร้อมใช้งาน <a href="/vehicle/drivers">จัดการคนขับรถ</a></Typography>}
                                            </Col>
                                        </Row>}
                                        {requiredCapacity > 0 && (
                                            <Row>
                                                <Col xs={12} style={{ marginBottom: 10 }}>
                                                    <div style={{
                                                        padding: "8px 14px",
                                                        backgroundColor: "#e8f5e9",
                                                        border: "1px solid #c8e6c9",
                                                        borderLeft: "4px solid #43a047",
                                                        borderRadius: 4,
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "space-between",
                                                        flexWrap: "wrap",
                                                        gap: 8
                                                    }}>
                                                        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                                            <i className="fa fa-users" style={{ color: "#2e7d32", fontSize: "1.1rem" }}></i>
                                                            <span style={{ fontSize: "0.95rem", color: "#1b5e20", fontWeight: 600 }}>
                                                                จำนวนผู้โดยสารสูงสุดที่ต้องรองรับ: <strong style={{ fontSize: "1.05rem" }}>{requiredCapacity}</strong> คน
                                                                {assignment.turnKey === 1 && (
                                                                    <span style={{ fontSize: "0.85rem", color: "#555", fontWeight: "normal", marginLeft: 6 }}>
                                                                        (ขาไป {goPassengers} คน, ขากลับ {backPassengers} คน)
                                                                    </span>
                                                                )}
                                                            </span>
                                                        </div>
                                                        <span style={{ fontSize: "0.85rem", color: "#374151" }}>
                                                            * เลือกรถได้เฉพาะคันที่มีความจุตั้งแต่ <strong>{requiredCapacity}</strong> ที่นั่งขึ้นไป
                                                        </span>
                                                    </div>
                                                </Col>
                                            </Row>
                                        )}
                                        <Row>
                                            <Col xs={12} sm={6} md={6}>
                                                <TSSelect2
                                                    label="รถ"
                                                    options={resourceOptions.vehicles}
                                                    isDisabled={!isLast || savingAssignments || !draftAvailability.ready}
                                                    value={assignment.vehicleKey}
                                                    onChange={e =>
                                                        handleAssignmentChange(index, "vehicleKey", e.value)
                                                    }
                                                />
                                                {(() => {
                                                    const chosen = resourceOptions.vehicles.find(v => v.value === Number(assignment.vehicleKey));
                                                    if (chosen && chosen.isDisabled) {
                                                        return (
                                                            <div style={{ color: red[700], fontSize: "0.85rem", marginTop: -6, marginBottom: 6 }}>
                                                                <i className="fa fa-exclamation-triangle" style={{ marginRight: 4 }}></i>
                                                                {chosen.reason || "รถที่เลือกไว้ไม่สามารถใช้งานได้"}
                                                            </div>
                                                        );
                                                    }
                                                    if (assignment.vehicleKey && !chosen) {
                                                        return (
                                                            <div style={{ color: red[700], fontSize: "0.85rem", marginTop: -6, marginBottom: 6 }}>
                                                                <i className="fa fa-exclamation-triangle" style={{ marginRight: 4 }}></i>
                                                                {requiredCapacity > 0
                                                                    ? `รถที่เลือกไว้มีที่นั่งไม่เพียงพอสำหรับผู้โดยสาร ${requiredCapacity} คน กรุณาเลือกรถใหม่`
                                                                    : "รถที่เลือกไว้ไม่สามารถใช้งานได้"}
                                                            </div>
                                                        );
                                                    }
                                                    return null;
                                                })()}
                                            </Col>
                                            <Col xs={12} sm={6} md={6}>
                                                <TSSelect2 label="ผู้ขับรถ" options={resourceOptions.drivers} value={assignment.driverUserName}
                                                    isDisabled={!isLast || savingAssignments || !draftAvailability.ready}
                                                    onChange={option => handleAssignmentChange(index, "driverUserName", option?.value || "")} />
                                            </Col>
                                        </Row>
                                    </fieldset>
                                </CardBody>
                                <CardFooter>
                                    {isLast && !isReadySave ?
                                        <Button2 color="primary" type="button" disabled={savingAssignments || !draftAvailability.ready} onClick={handleAddAssignment}>
                                            <h4>
                                                <i className={"fa fa-plus"}> บันทึกเที่ยวรถ</i>
                                            </h4>
                                        </Button2>
                                        : <></>
                                    }
                                </CardFooter>
                            </Card>
                        );
                    })}
                </Col>

                <Col xs={12} sm={12} md={12} style={{zIndex:0}}>
                    <Card>
                        <CardHeader color="primary">
                            <h4 className={classes.cardTitleWhite}>รายการขอใช้รถประจำวัน</h4>
                            <p className={classes.cardCategoryWhite}></p>
                        </CardHeader>
                        <CardBody>
                             <Row className="justify-content-center">
                                 {isReadySave ?
                                <Col xs={12} sm={6} className="mb-2">
                                    <Button2 color="success" type="button" disabled={savingAssignments || !draftAvailability.ready} onClick={handleSaveAssignments} block>
                                        <h4>
                                            <i className={savingAssignments ? "fa fa-spinner fa-spin" : "fa fa-save"}> {savingAssignments ? "กำลังบันทึก..." : "ยืนยันการบันทึกข้อมูล"}</i>
                                        </h4>
                                    </Button2>
                                </Col>
                                : <></>
                                }

                                <Col xs={12} sm={6} className="mb-2">
                                    <Button2 color="danger" type="button" disabled={savingAssignments} onClick={handleClear} block>
                                        <h4>
                                            <i className={"fa fa-plus"}> ยกเลิก</i>
                                        </h4>
                                    </Button2>
                                </Col>
                               
                            </Row>
                        </CardBody>
                    </Card>
                </Col>

            </Grid>
            </> 
            }
            <VehicleAssignmentCancellationDialog target={cancelTarget} onClose={() => setCancelTarget(null)}
                onBusyChange={busy => { cancellingAssignmentRef.current = busy; setCancellingAssignment(busy); }}
                onCancelled={async message => { setCancelTarget(null); setAssignmentError(""); setAssignmentSuccess(message); await fetchDataList(); }} />
            {editingTurn && <VehicleAssignmentTurnEditor key={`${editingTurn.turnId}-${editingTurn.goBackKey}`}
                turnId={editingTurn.turnId} goBackKey={editingTurn.goBackKey} onClose={() => setEditingTurn(null)}
                onSaved={message => { setEditingTurn(null); setAssignmentError(""); setAssignmentSuccess(message); fetchDataList(); }} />}
        </div>
    );
};

export default function ProtectedVehicleQueueManage(props) {
    return (
        <VehicleAdminGuard>
            <VehicleQueueManage {...props} />
        </VehicleAdminGuard>
    );
}
